import "./about.style.scss";

const AboutLibrary = () => {
  return (
    <section className="library-about">
      <div className="about-hero">
        <div className="overlay">
          <span className="badge">Since 1985</span>

          <h1>Jahangirnagar University Library</h1>

          <p>
            A vibrant center of knowledge, research, and innovation supporting
            generations of students, faculty, and researchers.
          </p>
        </div>
      </div>

      <div className="container1">
        <div className="about-content">
          <div className="section-heading">
            <span>ABOUT THE LIBRARY</span>
            <h2>Empowering Learning & Research Excellence</h2>
          </div>

          <p>
            Established in 1985, the Jahangirnagar University Library is one of
            the university’s most important academic and research facilities.
            Situated behind the iconic Sangshaptak monument, the library enjoys
            a central location between the academic buildings and residential
            halls, making it highly accessible to students, faculty members, and
            researchers.
          </p>

          <p>
            The library houses a rich and diverse collection of resources,
            supporting teaching, learning, and advanced research across various
            disciplines. With spacious reading spaces, natural lighting, modern
            facilities, and a welcoming academic atmosphere, the library
            continues to be a cornerstone of intellectual growth at
            Jahangirnagar University.
          </p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>115K+</h3>
            <p>Books Collection</p>
          </div>

          <div className="stat-card">
            <h3>7.5K+</h3>
            <p>Thesis</p>
          </div>

          <div className="stat-card">
            <h3>45K+</h3>
            <p>Online Journals</p>
          </div>

          <div className="stat-card">
            <h3>17k+</h3>
            <p>E-books</p>
          </div>

        </div>

        <div className="vision-mission">
          <div className="vm-card vision">
            <div className="icon">🎯</div>
            <h3>Vision</h3>

            <p>
              To be a leading academic library that provides world-class
              information resources, innovative services, and a conducive
              learning environment for education and research.
            </p>
          </div>

          <div className="vm-card mission">
            <div className="icon">🚀</div>

            <h3>Mission</h3>

            <ul>
              <li>Support academic and research goals.</li>
              <li>Provide equitable access to information.</li>
              <li>Preserve scholarly outputs.</li>
              <li>Develop information literacy skills.</li>
              <li>Adopt modern technologies for services.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutLibrary;